import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from '@/config/environments/environment';
import { SCOPES } from '@/core/constants/scopes';
import { getStorageObject } from '@/core/utils/storage-manager';

type Scope = (typeof SCOPES)[keyof typeof SCOPES];

@Injectable({
  providedIn: 'root'
})
export class ScopeService {
  private scopes = new BehaviorSubject<Scope[]>([]);

  constructor() {
    this.scopes.next(
      (
        getStorageObject(environment.userDataStorage) as { permissions: { ticket_scopes: { scope: Scope }[] } }
      )?.permissions?.ticket_scopes.map((scope) => scope.scope) ?? []
    );
  }

  getScopes(): Observable<Scope[]> {
    return this.scopes.asObservable();
  }

  hasScope(scope: Scope): boolean {
    return this.scopes.getValue().includes(scope);
  }

  hasAnyPermission(scopes: Scope[]): boolean {
    // If the user has no scopes ==> full access
    if (this.scopes.getValue().length === 0) {
      return true;
    }

    return scopes.some((scope) => this.hasScope(scope));
  }

  setScopes(scopes: Scope[]): void {
    this.scopes.next(scopes);
  }
}
